import * as _ from "lodash";
import * as assert from "assert";

import PreLoader from "./PreLoader";
import loadDependencies from "./DependencyHandler";
import { GlobalResourceManager } from "../../helpers/GlobalResourceManager";
import setExterns from "./externs";

export default class BasePlayer {
  // public isLibPreloaded = false;
  // private contentLib;
  protected content;
  public overrideLoad = false;
  private lastLauncherDependency: string;
  private library;
  constructor(public config) { }

  private initLauncher(lastLauncherDependency): void {
    console.log("lastLauncherDependency", lastLauncherDependency);
    setExterns();
    this.library = _.get(window, _.camelCase(lastLauncherDependency));
    this.library.default.init(
      this.config.questionProps ||
      this.config.itemProps ||
      this.config.activityProps
    );
  }

  public async startLauncher(): Promise<any> {
    this.lastLauncherDependency = await loadDependencies(this.config);
    this.initLauncher(this.lastLauncherDependency);
  }

  /**
   * Loads lib file, if not preloaded
   */
  public async loadLib(): Promise<void> {
    assert(this.config.paths.lib, "lib path not defined in config");
    // await this.loadDependencies();
    // let contentLib = getLibFromPath(this.config.paths.lib.slice());
    // if (contentLib === undefined) {
    //   await getContentLibrary(this.config.paths.lib.slice());
    //   contentLib = getLibFromPath(this.config.paths.lib.slice());
    // }
    // // let { isLibPreloaded, ContentLib } = getLibFromPath(this.config.paths.lib.slice());
    // this.isLibPreloaded = false;
    // this.contentLib = contentLib;
    GlobalResourceManager.loadLibOnly(
      this.config.paths.lib.slice(),
      this.config.contentTypeID
    );
    return;
  }

  // public async loadResources(resources): Promise<{}> {
  //     await this.loadSounds(resources.sounds);
  //     await this.loadImages(resources.images);
  //     await this.loadFonts(resources.fonts);
  //     return {};
  // }

  // public async loadSounds(sounds: Array<string>): Promise<void> {
  //     let p: Array<Promise<{}>> = [];
  //     _.forEach(sounds, sound => AudioHelper.makeAudioBuffer(sounds.slice()));
  // }

  /**
   * Loads lib file and its resources, if not preloaded.
   */
  public async loadLibWithResources(): Promise<void> {
    let content = await GlobalResourceManager.loadResource(
      this.config,
      this.config.contentTypeID,
      this.config.paths
    );
    if (this.content) {
      return;
    }
    let lib = GlobalResourceManager.getContentLib(this.config.contentTypeID);
    this.content = new lib(this.config);
  }

  /**
   * Loads lib file, its resources, if not preloaded. Also, calls the play method of lib file.
   */
  public async start(): Promise<any> {
    await this.loadLibWithResources();
    this.hideDefaultLoader();
    let result = await this.content.play();
    return result;
  }

  public hideDefaultLoader(): void {
    PreLoader.hideLoader();
  }

  public cleanPlayer(): void {
    if (this.content.releaseResources !== undefined) {
    }
    {
      this.content.releaseResources();
    }
    this.content = null;
    // this.contentLib = null;
  }
}
